import { useIntl } from "react-intl";
import { Modal, Box, IconButton, Button, Typography } from "@mui/material";
import PageHeader from "../ui/PageHeader";
import { useEffect, useState } from "react";
import { useLoading } from "../../components/LoadingContext";
import axios from "../../api/axiosClient";
import {
  handleError,
  errorToast,
  addDownloadLinkToDocument,
} from "../../services/serviceBase";
import CustomGridHeaderCell from "../ui/CustomGridHeaderCell";
import CustomTable from "../ui/CustomTable";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useSelector, useDispatch } from "react-redux";
import { setActAs } from "../../redux/actasSlice";
import { Navigate, useNavigate } from "react-router-dom";
import CustomGridCell from "../ui/CustomGridCell";

const ActAsModal = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  var navigate = useNavigate();

  const modalStyle = {
    position: "relative",
    top: "40%",
    left: "45%",
    width: "80%",
    ml: "7%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    p: 4,
    borderRadius: 2,
  };

  const { setLoading } = useLoading();

  const [shopsData, setShopsData] = useState([]);
  const [columns, setColumns] = useState([]);

  const getShopsByCustomer = async () => {
    setLoading(true);
    axios
      .get(`/customers/search/${props.customerCode}`)
      .then((response) => {
        setLoading(false);
        setShopsData(response.data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleActAs = (e, row) => {
    dispatch(
      setActAs({
        customerCode: row.customerCode,
        customerDescription: row.customerDescription,
        jdaLocationCode: row.jdaLocation,
        jdaLocationDescription: row.jdaLocationDescr,
        shopCode: row.shopCode,
        shopDescription: row.shopDescription,
      })
    );
    navigate(`${process.env.PUBLIC_URL}/`);
  };

  const handleActAsCustomer = (e, row) => {
    dispatch(
      setActAs({
        customerCode: props.customerCode,
        customerDescription: props.customerDescription,
        jdaLocationCode: null,
        jdaLocationDescription: null,
        shopCode: null,
        shopDescription: null,
      })
    );
    navigate(`${process.env.PUBLIC_URL}/`);
  };

  const getColumns = () => {
    let columnColor = props.withStealthFlow ? "#7f7f7f" : "white"
    setColumns([
      {
        field: "actions",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        flex: 1,
        minWidth: 50,
        maxWidth: 80,
        renderCell: (params) => {
          return (
            <IconButton
              aria-label="go"
              size="large"
              color="primary"
              onClick={(event) => handleActAs(event, params.row)}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          );
        },
      },
      {
        field: "shopCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "ActAs.SapSite" })}
            color={columnColor}
          />
        ),
        flex: 1,
        renderCell: (params) => {
          return (
            <CustomGridCell
              item1={params.row.shopCode}
              width="100%"
              heigth="100%"
              display={props.withStealthFlow ? "none" : "flex"}
              alignItems="center"
              color="black"
            />
          );
        },
      },
      {
        field: "stealthShopCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "ActAs.StealthDoor" })}
          />
        ),
        flex: 1,
      },
      {
        field: "shopDescription",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "ActAs.Description" })}
          />
        ),
        flex: 1,
      },
      {
        field: "address",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "ActAs.Address" })}
          />
        ),
        flex: 1,
      },
      {
        field: "city",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "ActAs.City" })}
          />
        ),
        flex: 1,
      },
      {
        field: "zip",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "ActAs.Zip" })}
          />
        ),
        flex: 1,
      },
      {
        field: "countryName",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "ActAs.Country" })}
          />
        ),
        flex: 1,
      },
    ]);
  };

  useEffect(() => {
    if (
      props.customerCode !== null &&
      props.customerCode !== undefined &&
      props.customerCode !== "" &&
      props.openModal
    ) {
      getShopsByCustomer();
      getColumns();
    }
  }, [props.openModal]);

  const handleClose = () => {
    props.handleCloseModal();
    setShopsData([]);
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader title={intl.formatMessage({ id: "General.Customer" })+": "+props.customerCode + " - " + props.customerDescription} />
        {shopsData !== null && shopsData != [] ? (
          <CustomTable
            columns={columns}
            rows={shopsData}
            id={"shopCode"}
            rowHeight={50}
            headerHeight={50}
            tableHeight={420}
          />
        ) : (
          ""
        )}

        <Button
          variant="contained"
          className="apeLigthBlueBackground"
          sx={{mt: 1}}        
          onClick={handleActAsCustomer}
        >
          {intl.formatMessage({ id: "ActAs.UseCustomer" })}
        </Button>
      </Box>
    </Modal>
  );
};

export default ActAsModal;
